import { useState, Fragment } from "react";
import { Drawer, Typography, Button, Tabs, Grid } from "antd";
import { useAppSelector } from "store/hook";
import Layout from "Components/Report/OnDemand/chartsList/preference/layout";
import Order from "Components/Report/OnDemand/chartsList/preference/order";

const { TabPane } = Tabs;

const { Text } = Typography;

const { useBreakpoint } = Grid;

const PreferenceDrawer = () => {
  const screens = useBreakpoint();
  const [visible, setVisible] = useState(false);
  const { preference } = useAppSelector((state) => state.report);

  function callback(key: string) {
    console.log(key);
  }

  return (
    <div style={!screens.lg ? { display: "none" } : {}}>
      <Button onClick={() => setVisible(true)}>Preference</Button>
      <Drawer
        title={<Text>Preference</Text>}
        width={"30%"}
        onClose={() => setVisible(false)}
        visible={visible}
        destroyOnClose
      >
        <Tabs defaultActiveKey="1" onChange={callback}>
          <TabPane tab="Account Level" key="1">
            <Layout type="account" />
            <Order type="account" preference={preference} />
          </TabPane>
          <TabPane tab="Device Level" key="2">
            <Layout type="device" />
            <Order type="device" preference={preference} />
          </TabPane>
        </Tabs>
      </Drawer>
    </div>
  );
};

export default PreferenceDrawer;
